import { useState, useCallback } from 'react';

import { useSubscriptionEvent } from '@confluence/graphql/entry-points/useSubscriptionEvent';
import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

interface RealtimeAccessRequestsFlagsProps {
	contentType: string;
	contentId: string;
	flags: FlagsStateContainer;
}

// Called in response to a ping that there is a real-time access request
export const useRealtimeAccessRequestsFlags = ({
	contentId,
	contentType,
}: RealtimeAccessRequestsFlagsProps) => {
	const [_] = useState(Date.now());

	const showRealtimeFlag: Parameters<typeof useSubscriptionEvent>[0]['onDataReceived'] =
		useCallback(() => {
			/**
			 * Call API to get Access Request data up to Earliest request time
			 *   Dismiss any currently displayed flag
			 *   IF only 1 request
			 *       Also validate if blocked acccess needs to show
			 *           If no blockage
			 *               show regular flag with Approve / Deny buttons
			 *           If blockage
			 *               If empowered
			 *                   show blocked flag with extra copy and Approve / Deny buttons
			 *               If not empowered
			 *                   Don't show flag
			 *   IF more than 1 request
			 *       show regular flag for many users only with "View detils" CTA
			 */
		}, []);

	useSubscriptionEvent({
		contentId,
		contentType,
		delta: 'contentAccessRequested',
		subscriberId: 'realtimeAccessRequests',
		onDataReceived: showRealtimeFlag,
	});

	return { showRealtimeFlag };
};
